import React from 'react';
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {observer} from 'mobx-react';
import styles from "./game-scoreboard.module.scss";
import classNames from "classnames";

export class GameScoreboardCurrentScoreProps extends BaseProps {
  shouldRenderFullScoreboard: boolean;
  currentScore: String;
}

export const GameScoreboardCurrentScore = observer(({shouldRenderFullScoreboard, currentScore}: GameScoreboardCurrentScoreProps) => {

  return (shouldRenderFullScoreboard ?
          <div className={classNames(styles.current_score_container)}>
        {currentScore}
      </div> : null
  )
});
